var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faq" },
    _vm._l(_vm.faqsList, function(faqsObj, index) {
      return _c(
        "accordion-group",
        { key: index, staticClass: "faq__category" },
        [
          _c("span", { staticClass: "faq__title h3" }, [
            _vm._v(_vm._s(faqsObj.category))
          ]),
          _vm._l(faqsObj.values, function(faq, subindex) {
            return _c(
              "accordion",
              {
                key: subindex,
                attrs: {
                  heading: faq.question,
                  activeIcon: "minus",
                  "auto-close": false,
                  theme: "faq"
                }
              },
              [
                _c("div", {
                  staticClass: "faq__answer client-generated",
                  domProps: { innerHTML: _vm._s(faq.answer) }
                })
              ]
            )
          })
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }